import { render, staticRenderFns } from "./TagHistoryPopup.vue?vue&type=template&id=408ea5e4&scoped=true"
import script from "./TagHistoryPopup.vue?vue&type=script&lang=js"
export * from "./TagHistoryPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408ea5e4",
  null
  
)

export default component.exports